// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3B3AP","content":"GlobalSearch_content__kaNLp"};